import { useState } from 'react'
import { AspectRatio, Image, Skeleton } from '@mantine/core'
import { TeamList } from './api'
import { Typography } from '../common/typography'
import classes from './Teams.module.css'
import clsx from 'clsx'

export default function TeamCard({
  team,
  isSinglePlayerTeam = false,
}: {
  team: TeamList
  isSinglePlayerTeam: boolean
}) {
  const [teamImageLoaded, setTeamImageLoaded] = useState<boolean>(false)

  return (
    <div className={classes.team_card_container}>
      <AspectRatio ratio={1 / 1} className={classes.aspect_ratio}>
        {!teamImageLoaded && <Skeleton circle height="100%" />}
        <Image
          src={team.logo.main}
          alt={team.name}
          className={clsx(classes.team_logo, {
            [classes.singlePlayerTeamLogo]: isSinglePlayerTeam,
          })}
          onLoad={() => setTeamImageLoaded(true)}
          data-loaded={teamImageLoaded}
          fit="scale-down"
        />
      </AspectRatio>
      <Typography fs="sm" ta="center" lh="140">
        {team.name}
      </Typography>
    </div>
  )
}
